import { svg, TemplateResult } from 'lit-html';

export const defaultImageIcon = svg`
    <svg width="254" height="254" viewBox="0 0 254 254" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="254" height="254" fill="#D9DCE9"/>
        <path
            d="M126.732 95.2623C126.483 95.2873 126.239 95.3458 126.008 95.4359L96.8321 106.549C96.3618
            106.731 95.9603 107.037 95.6786 107.43C95.397 107.823 95.2478 108.285 95.2499 108.757V145.27C95.2531
            145.738 95.4047 146.194 95.6861 146.582C95.9674 146.97 96.366 147.273 96.8321 147.453L126.008
            158.566C126.322 158.687 126.659 158.75 127 158.75C127.341 158.75 127.678 158.687 127.992
            158.566L157.168 147.453C157.634 147.273 158.032 146.97 158.314 146.582C158.595 146.194 158.747
            145.738 158.75 145.27V108.757C158.752 108.285 158.603 107.823 158.321 107.43C158.04 107.037 157.638
            106.731 157.168 106.549L127.992 95.4359C127.594 95.2813 127.161 95.2216 126.732 95.2623ZM127 100.199L149.418
            108.757L127 117.29L104.582 108.757L127 100.199ZM100.399 112.304L124.426 121.457V152.811L100.399
            143.658V112.304ZM153.601 112.304V143.658L129.574 152.811V121.457L153.601 112.304Z" fill="white"
        />
    </svg>
`;

export const star = (color: string): TemplateResult => {
    return svg`
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M9.52447 1.46353C9.67415 1.00287 10.3259 1.00287 10.4755 1.46353L12.1329 6.56434C12.1998 6.77035
                12.3918 6.90983 12.6084 6.90983H17.9717C18.4561 6.90983 18.6575 7.52964 18.2656 7.81434L13.9266
                10.9668C13.7514 11.0941 13.678 11.3198 13.745 11.5258L15.4023 16.6266C15.552 17.0873 15.0248 17.4704
                14.6329 17.1857L10.2939 14.0332C10.1186 13.9059 9.88135 13.9059 9.70611 14.0332L5.3671 17.1857C4.97524
                17.4704 4.448 17.0873 4.59768 16.6266L6.25503 11.5258C6.32197 11.3198 6.24864 11.0941 6.07339 10.9668L1.73438
                7.81434C1.34253 7.52964 1.54392 6.90983 2.02828 6.90983H7.39159C7.6082 6.90983 7.80018 6.77035 7.86712
                6.56434L9.52447 1.46353Z" fill="${color}"
            />
        </svg>
    `;
};

export const halfStar = (fullColor: string, emptyColor: string): TemplateResult => {
    return svg`
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M9.52447 1.46353C9.67415 1.00287 10.3259 1.00287 10.4755 1.46353L12.1329 6.56434C12.1998 6.77035
                12.3918 6.90983 12.6084 6.90983H17.9717C18.4561 6.90983 18.6575 7.52964 18.2656 7.81434L13.9266
                10.9668C13.7514 11.0941 13.678 11.3198 13.745 11.5258L15.4023 16.6266C15.552 17.0873 15.0248 17.4704
                14.6329 17.1857L10.2939 14.0332C10.1186 13.9059 9.88135 13.9059 9.70611 14.0332L5.3671 17.1857C4.97524
                17.4704 4.448 17.0873 4.59768 16.6266L6.25503 11.5258C6.32197 11.3198 6.24864 11.0941 6.07339 10.9668L1.73438
                7.81434C1.34253 7.52964 1.54392 6.90983 2.02828 6.90983H7.39159C7.6082 6.90983 7.80018 6.77035 7.86712
                6.56434L9.52447 1.46353Z" fill="${emptyColor}"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10 1.125C9.79968 1.125 9.59934 1.24016 9.5245 1.47049L7.86714 6.5713C7.80021 6.77732 7.60823 6.9168
                7.39161 6.9168H2.0283C1.54394 6.9168 1.34255 7.5366 1.73441 7.8213L6.07342 10.9738C6.24866 11.1011
                6.32199 11.3268 6.25506 11.5328L4.5977 16.6336C4.44803 17.0943 4.97527 17.4773 5.36712 17.1926L9.70613
                14.0402C9.79375 13.9765 9.89689 13.9447 10 13.9447V1.125Z" fill="${fullColor}"
            />
        </svg>
    `;
};
